import React, { useState } from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import Grid from "./Layouts/Grid";
import Carousel from "./Layouts/Carousel";

import "./PerformanceResults.scss";
export const PerformanceResults = ({
    settings,
    columns }) => {
    let isMobile = useMobileBreakpoint(settings.mobile_breakpoint || "1024px");

    const LayoutComponent = isMobile ? Carousel :  Grid;

    return (
    <>
      <LayoutComponent
          settings={settings}
          section={settings.section}
          columns={columns}
      />
    </>
  );
};

export default PerformanceResults;